import { Stack, styled } from '@mui/material';
import { TableCustom, TableDataType } from 'app/components/elements/TableCustom';
import { TextEllipsis } from 'app/components/elements/TextEllipsis';
import { ButtonCustom } from 'app/components/elements/ButtonCustom';
import React, { memo } from 'react';
import { useInjection } from './hook';
import { ModalAddNewTriggerType } from './ModalAddNewTriggerType';
import { HEADER_TRIGGER_TYPES_TAB } from '../../../const';
import { TriggerType } from '../../../type';

const renderDataTriggerTypes = (
  triggerTypes: TriggerType[],
  onClickEdit: (item: TriggerType) => void
): TableDataType[] =>
  triggerTypes.map((item) => ({
    name: {
      value: <TextEllipsis text={item.name} width={'95%'} />
    },
    actions: {
      value: (
        <Stack flexDirection={'row'} gap={'10px'} alignItems={'center'}>
          <img
            style={{ cursor: 'pointer' }}
            onClick={() => onClickEdit(item)}
            src={'/icons/icon_action_edit.svg'}
            alt={'icon_action_edit'}
          />
        </Stack>
      )
    }
  }));

export const TriggerTypesTab = () => {
  const {
    triggerTypes,
    showModalAddNew,
    setShowModalAddNew,
    typeEdit,
    setTypeEdit,
    asyncAddNewType,
    asyncEditType
  } = useInjection();

  return (
    <WrapperTab>
      <Stack sx={{ justifyContent: 'flex-end', marginBottom: '20px' }} direction="row">
        <ButtonCustom
          style={{ display: 'inline-block', width: 'auto' }}
          onClick={() => setShowModalAddNew(true)}
          label="Add New Trigger Type"
        />
      </Stack>
      <TableCustom
        data={renderDataTriggerTypes(triggerTypes, (item) => setTypeEdit(item))}
        headers={HEADER_TRIGGER_TYPES_TAB}
        handleChooseRow={() => {}}
        styledTableRow={{ cursor: ' default ' }}
      />
      <ModalAddNewTriggerType
        isOpen={showModalAddNew}
        onCloseModal={() => setShowModalAddNew(false)}
        onSubmit={asyncAddNewType}
      />
      <ModalAddNewTriggerType
        isEdit
        initData={typeEdit}
        isOpen={!!typeEdit}
        onCloseModal={() => setTypeEdit(undefined)}
        onSubmit={asyncEditType}
      />
    </WrapperTab>
  );
};

export const MemoTriggerTypesTab = memo(TriggerTypesTab);

const WrapperTab = styled(Stack)(() => ({
  width: '100%',
  marginTop: 20
}));
